import toast from "@safecv/shared/toast";
import MESSAGE from "@safecv/shared/message";

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export const copyToClipboard = async(textToCopy) => {
    //navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      try {
        await navigator.clipboard.writeText(textToCopy);
        toast.success(MESSAGE.COPY_SUCCESS);
      } catch (err) {
        toast.error(MESSAGE.COPY_FAILURE);
      }
    } 
    else {
      var textarea = document.createElement("textarea");
      textarea.textContent = textToCopy;
      document.body.appendChild(textarea);
      // make the textarea out of viewport
      textarea.style.position = "fixed";
      textarea.style.left = "-999999px";
      textarea.style.top = "-999999px";

      var selection = document.getSelection();
      var range = document.createRange();
      //range.selectNodeContents(textarea);
      range.selectNode(textarea);
      selection.removeAllRanges();
      selection.addRange(range);
      try {
        document.execCommand("copy")
          ? toast.success(MESSAGE.COPY_SUCCESS)
          : toast.error(MESSAGE.COPY_FAILURE);
      } catch (err) {
        toast.error(MESSAGE.COPY_FAILURE);
      }
      selection.removeAllRanges();
      document.body.removeChild(textarea);
    }
  };